export default __webpack_public_path__ + "static/media/backup-manager.3c93c8ee.svg";